import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';




const SubMenuNav = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const scrollRef = useRef(null);

    const menuOptions = [
        { label: t('nav.home'), path: '/', icon: 'bi bi-house-door' },
        { label: t('nav.menu'), path: '/menu', icon: 'bi bi-grid-3x3-gap' },
        // { label: t('nav.about'), path: '/about', icon: 'uil uil-store' },
        { label: t('nav.orders'), path: '/orders', icon: 'bi bi-bag-check' },
        // { label: 'Cupones', path: '/', icon: 'uil uil-pricetag-alt' },
        // { label: 'Puntos', path: '/', icon: 'uil uil-coins' },
        { label: t('nav.contact'), path: '/contact', icon: 'bi bi-headset' },

    ];

    const scroll = (direction) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: direction === 'left' ? -200 : 200, behavior: 'smooth' });
        }
    };
    const [activeLink, setActiveLink] = useState("inicio");

    const handleLink = id => { setActiveLink(id); };

    return (
        <>



            {/* <ul className="nav-menu">
                {menuOptions.map((item, index) => (
                    <li className="nav-item-custom" key={index} onClick={() => !item.subItems && navigate(item.path)}>
                        <a className="nav-link-modern">
                            <i className={item.icon}></i>
                            <span>{item.label}</span>
                        </a>
                    </li>
                ))}
            </ul> */}

            {menuOptions.map(item => (
                <button
                    key={item.path}
                    className={`dn-link${activeLink === item.path ? " active" : ""}`}
                    onClick={() => {
                        if (!item.subItems) {
                            navigate(item.path);
                            handleLink(item.path);
                        }
                    }}
                >
                   <i className={item.icon}></i> {item.label}
                </button>
            ))}



        </>
    )
}

export default SubMenuNav
